import request from '@/utils/request'

// 获取仪表盘概览数据
export function getDashboardOverview() {
  return request({
    url: '/api/dashboard/overview',
    method: 'get'
  })
}

// 获取销售趋势数据
export function getSalesTrend(params) {
  return request({
    url: '/api/dashboard/sales-trend',
    method: 'get',
    params
  })
}

// 获取客户增长趋势
export function getCustomerTrend(params) {
  return request({
    url: '/api/dashboard/customer-trend',
    method: 'get',
    params
  })
}

// 获取热销商品
export function getHotProducts(params) {
  return request({
    url: '/api/dashboard/hot-products',
    method: 'get',
    params
  })
} 


export function getMainNum() {
  return request({
    url: '/move/getMainNum',
    method: 'get'
  })
}

export function getEcharts(params) {
  return request({
    url: '/move/getEcharts',
    method: 'get',
    params
  })
}

export function getEchartsZhu(params) {
  return request({
    url: '/move/getEchartsZhu',
    method: 'get',
    params
  })
}

export function getMainList(params) {
  return request({
    url: '/move/getMainList',
    method: 'get',
    params
  })
}